import { TypeProduct, TypeProductFields } from '@/core/generated-types';
import { decodeProductId } from '@/utils/helpers';
import {
  shopifyProductFieldMapping,
  shopifyProductField,
} from '@/core/contentfulConfig';
import {
  getShopifyDomain,
  isStageEnvironment,
  YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS,
} from '@/core/constants';

export function getShopifyProductId(
  product: TypeProduct,
  shouldUsePlayKitId?: boolean,
) {
  let productIdKey = null;

  if (!product) return null;

  if (product.fields?.isPlayKit && !shouldUsePlayKitId) {
    return YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS[getShopifyDomain()];
  }

  productIdKey = shopifyProductField() as keyof TypeProductFields;

  // Replace the field name with the production field name if in staging
  if (isStageEnvironment()) {
    productIdKey = shopifyProductFieldMapping(
      productIdKey,
    ) as keyof TypeProductFields;
  }
  const productId = product.fields[productIdKey] as string | undefined;

  if (!productId) return null;

  return decodeProductId(productId);
}
